module.exports = __webpack_public_path__ + "static/collaboration@2x-352679498af1b5bb4448664aec7ff3f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/collaboration@2x.png
// module id = 2719
// module chunks = 168707334958949